export const en = ({
  filters: {
    popovers: {
      'external id': {
        label: 'Card ID',
      },
      fio: {
        label: 'Full name',
      },
      date: {
        label: 'Date created',
      },
      lists: {
        label: 'Lists',
      },
    },
    buttons: {
      'reset button': {
        label: 'Reset',
      },
    },
  },
  features: {
    'face duplicate': {
      'confirm popup': {
        title: 'A chance of a duplicate',
        description: 'The face you are adding probably already exists in the card',
        buttons: {
          'face sample button': 'Face details',
          'submit button': 'Add anyway',
          'reject button': 'Cancel',
        },
      },
    },
  },
  'sort dropdown options': {
    date_asc: 'By creation date (oldest first)',
    date_desc: 'By creation date (newest first)',
    fio_asc: 'By full name (A to Z)',
    fio_desc: 'By full name (Z to A)',
  },
  'person card': {
    created: 'Created',
    details: 'Details',
  },
  title: 'Card list',
  'create button': 'Card',
  'cards found': 'Cards found: {{count}}',
  'cards found_one': 'Cards found: {{count}}',
  'cards found_few': 'Cards found: {{count}}',
  'cards found_many': 'Cards found: {{count}}',
  'cards found_other': 'Cards found: {{count}}',
  'quick search input label': 'Card ID or Full Name',
  copy: {
    copy: 'Copy',
    copied: 'Copied',
  },
  'bulk actions': {
    'selected count': 'Selected cards: {{count}}',
    delete: 'Delete',
  },
  table: {
    columns: {
      card_id: 'Card ID',
      main_face_id: 'Photo',
      user_data: 'Name',
      create_time: 'Created at',
      lists: 'Lists',
    },
  },
}) as Record<string, unknown>;
export const ru = ({
  filters: {
    popovers: {
      'external id': {
        label: 'ID карточки',
      },
      fio: {
        label: 'ФИО',
      },
      date: {
        label: 'Дата создания',
      },
      lists: {
        label: 'Списки',
      },
    },
    buttons: {
      'reset button': {
        label: 'Очистить',
      },
    },
  },
  'sort dropdown options': {
    date_asc: 'По дате создания (сначала старые)',
    date_desc: 'По дате создания (сначала новые)',
    fio_asc: 'По ФИО (от А до Я)',
    fio_desc: 'По ФИО (от Я до А)',
  },
  'person card': {
    created: 'Создана',
    details: 'Детали',
  },
  title: 'Картотека',
  'create button': 'Карточка',
  'quick search input label': 'ID Карточки или ФИО',
  'cards found': 'Найдено карточек: {{count}}',
  'cards found_one': 'Найдено карточек: {{count}}',
  'cards found_few': 'Найдено карточек: {{count}}',
  'cards found_many': 'Найдено карточек: {{count}}',
  'cards found_other': 'Найдено карточек: {{count}}',
  copy: {
    copy: 'Копировать',
    copied: 'Скопировано',
  },
  features: {
    'face duplicate': {
      'confirm popup': {
        title: 'Вероятность дубликата',
        description: 'Лицо, которое вы добавляете, вероятно уже есть в карточке',
        buttons: {
          'face sample button': 'Детали лица',
          'submit button': 'Всё равно добавить',
          'reject button': 'Отмена',
        },
      },
    },
  },
  'bulk actions': {
    'selected count': 'Выбрано карточек: {{count}}',
    delete: 'Удалить',
  },
  table: {
    columns: {
      card_id: 'ID карточки',
      main_face_id: 'Фото',
      user_data: 'ФИО',
      create_time: 'Создана',
      lists: 'Списки',
    },
  },
}) as Record<string, unknown>;
export const ptBr = ({
  filters: {
    popovers: {
      'external id': {
        label: 'ID do cartão',
      },
      fio: {
        label: 'Nome completo',
      },
      date: {
        label: 'Data de criação',
      },
      lists: {
        label: 'Listas',
      },
    },
    buttons: {
      'reset button': {
        label: 'Repor',
      },
    },
  },
  features: {
    'face duplicate': {
      'confirm popup': {
        title: 'Possibilidade de duplicado',
        description: 'A face que está a adicionar provavelmente já existe no cartão',
        buttons: {
          'face sample button': 'Detalhes da face',
          'submit button': 'Adicionar mesmo assim',
          'reject button': 'Cancelar',
        },
      },
    },
  },
  'sort dropdown options': {
    date_asc: 'Por data de criação (mais antigos primeiro)',
    date_desc: 'Por data de criação (mais recentes primeiro)',
    fio_asc: 'Por nome completo (A a Z)',
    fio_desc: 'Por nome completo (Z a A)',
  },
  'person card': {
    created: 'Criado',
    details: 'Detalhes',
  },
  title: 'Lista de cartões',
  'create button': 'Cartão',
  'cards found': 'Encontrado: {{count}} cartão',
  'cards found_one': 'Encontrado: {{count}} cartão',
  'cards found_few': 'Encontrados: {{count}} cartões',
  'cards found_many': 'Encontrados: {{count}} cartões',
  'cards found_other': 'Encontrados: {{count}} cartões',
  'quick search input label': 'ID do cartão ou nome completo',
  'bulk actions': {
    'selected count': 'Cartões selecionados: {{count}}',
    delete: 'Excluir',
  },
  table: {
    columns: {
      card_id: 'ID do cartão',
      main_face_id: 'Fotos',
      user_data: 'Nome',
      create_time: 'Criar tempo',
      lists: 'Listas',
    },
  },
}) as Record<string, unknown>;
export const esEs = ({
  filters: {
    popovers: {
      'external id': {
        label: 'ID de tarjeta',
      },
      fio: {
        label: 'Nombre completo',
      },
      date: {
        label: 'Fecha de creación',
      },
      lists: {
        label: 'Listas',
      },
    },
    buttons: {
      'reset button': {
        label: 'Restablecer',
      },
    },
  },
  features: {
    'face duplicate': {
      'confirm popup': {
        title: 'Posibilidad de un duplicado',
        description: 'El rostro que está agregando probablemente ya existe en la tarjeta',
        buttons: {
          'face sample button': 'Detalles del rostro',
          'submit button': 'Agregar de todos modos',
          'reject button': 'Cancelar',
        },
      },
    },
  },
  'sort dropdown options': {
    date_asc: 'Por fecha de creación (más antiguos primero)',
    date_desc: 'Por fecha de creación (más recientes primero)',
    fio_asc: 'Por nombre completo (A a Z)',
    fio_desc: 'Por nombre completo (Z a A)',
  },
  'person card': {
    created: 'Creado',
    details: 'Detalles',
  },
  title: 'Lista de tarjetas',
  'create button': 'Tarjeta',
  'cards found': 'Encontrado: {{count}} tarjeta',
  'cards found_one': 'Encontrado: {{count}} tarjeta',
  'cards found_few': 'Encontrado: {{count}} tarjetas',
  'cards found_many': 'Encontrado: {{count}} tarjetas',
  'cards found_other': 'Encontrado: {{count}} tarjetas',
  'quick search input label': 'ID de tarjeta o nombre completo',
  'bulk actions': {
    'selected count': 'Tarjetas seleccionadas: {{count}}',
    delete: 'Eliminar',
  },
  table: {
    columns: {
      card_id: 'ID de tarjeta',
      main_face_id: 'Foto',
      user_data: 'Nombre',
      create_time: 'Creado el',
      lists: 'Listas',
    },
  },
}) as Record<string, unknown>;
